import React from 'react';

interface Props {
  className?: string;
}

const Building: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 16 21"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 0.5H0.5V20.5H6.125V15.5H9.875V20.5H15.5V0.5ZM3 9.25H5.5V11.75H3V9.25ZM9.25 9.25V11.75H6.75V9.25H9.25ZM10.5 9.25H13V11.75H10.5V9.25ZM5.5 4.25V6.75H3V4.25H5.5ZM6.75 4.25H9.25V6.75H6.75V4.25ZM13 4.25V6.75H10.5V4.25H13Z"
      fill="currentColor"
      id="Vector"
    />
  </svg>
);

export default Building;
